import React from "react";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/**
 * Turn plain-text URLs into clickable <a> nodes (keeps surrounding text).
 * Opens links in a new tab.
 */
export function linkifyText(text) {
  if (text == null || text === "") return null;
  const str = String(text);
  const nodes = [];
  let last = 0;
  let match;
  let key = 0;

  URL_REGEX.lastIndex = 0;
  while ((match = URL_REGEX.exec(str)) !== null) {
    if (match.index > last) {
      nodes.push(str.slice(last, match.index));
    }

    const raw = match[0];
    const cleaned = raw.replace(/[.,;:!?)\]}]+$/g, "");
    const trailing = raw.slice(cleaned.length);

    nodes.push(
      <a
        key={`url-${key++}`}
        href={cleaned}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#2563eb",
          textDecoration: "underline",
          wordBreak: "break-all",
          fontWeight: 600,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {cleaned}
      </a>,
    );

    if (trailing) nodes.push(trailing);
    last = match.index + raw.length;
  }

  if (last < str.length) nodes.push(str.slice(last));
  return nodes.length ? nodes : str;
}

export default linkifyText;
